/**
 *
 * Asynchronously loads the component for ReviewSuccess
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
